import React, {useEffect, useState} from 'react'
import {Col, message, Modal, Row} from 'antd'
import {CloseCircleOutlined} from '@ant-design/icons'
import './bookSettingsModal.css'
import BookSettings from '../bookSettings/BookSettings'
import {postSingleReservationSettingData} from '../../../../api/bookings'
import {useClubTableBookSettingContext} from "../bookSettings/store/useClubTableBookSettingContext"

const OK = 1

const BookSettingsModal = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [tableList, setTableList] = useState([])
    const [postBookingsData, setPostBookingsData] = useState(null)
    const [tableIds, setTableIds] = useState([])


    const {updateTableReservationSetting, form,} = useClubTableBookSettingContext()

    useEffect(() => {
        const {tables} = props
        const newArray = tables.map((item) => ({
            id: item.table_id,
            name: item.name,
        }))
        setTableList(newArray)
        setTableIds(newArray.map((it) => it.id))

    }, [props.tables])


    const deleteTable = (idx) => {
        if (tableList.length < 2) {
            return
        }
        const newArray = [...tableList]
        newArray.splice(idx, 1)
        setTableList(newArray)
    }

    const confirmEvent = () => {
        updateTableReservationSetting(tableIds,props.close)
    }

    const postBooksInfo = async () => {
        const {reservationProperty, beforeList, afterList} = postBookingsData
        const beFilter = beforeList.filter((bt) => bt.duration && bt.ratio)
        const afFilter = afterList.filter((bt) => bt.duration && bt.ratio)
        const cancelFee = [...beFilter, ...afFilter].map((item) => ({
            ...item,
            duration: item.duration * 60,
            ratio: item.ratio / 100,
        }))
        const params = {
            reservationProperty: {
                ...reservationProperty,
                // minReservationDuration: reservationProperty.minReservationDuration * 60,
            },
            cancelFee,
            tableIds: tableList.map((it) => it.id),
        }
        setIsLoading(true)
        const {status, detail} = await postSingleReservationSettingData(params)
        setIsLoading(false)
        if (status !== OK) {
            message.error(detail)
            return
        }
        message.success('设置成功')
        props.close()
    }

    const onBookingsDataChange = (data) => {
        setPostBookingsData(data)
    }

    useEffect(() => {
        form.resetFields()
    }, [])

    const handleOnCancel = () => {
        form.resetFields()
        props.close()
    }

    return (
        <Modal
            title="批量设置"
            visible
            width="70vw"
            onOk={confirmEvent}
            onCancel={handleOnCancel}
            confirmLoading={isLoading}
        >
            <div className="book_settings_modal">
                <div className="table_lists_view">
                    <Row gutter={[20, 20]}>
                        {tableList.length > 0 &&
                            tableList.map((item, idx) => (
                                <Col span={4} key={idx}>
                                    <div className="col_table_item">
                                        <span className="table_name_text">{item.name}</span>
                                        <div className="close_icon" onClick={() => deleteTable(idx)}>
                                            <CloseCircleOutlined
                                                width={30}
                                                height={30}
                                                style={{fontSize: 20, color: '#fff'}}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            ))}
                    </Row>
                </div>
                <div className="book_setts_tip_view">预订设置</div>
                <BookSettings
                    tableIds={tableIds}
                    isBatch={true}
                />
            </div>
        </Modal>
    )
}

export default BookSettingsModal


// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/bookSettingsModal/bookSettingsModal.js